import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChipModule } from 'primeng/chip';
import { StandaloneSharedModule } from '../standalone-shared-module';

@Component({
  selector: 'app-num-picker',
  imports: [ChipModule, StandaloneSharedModule],
  standalone: true,
  templateUrl: './num-picker.component.html',
  styleUrl: './num-picker.component.css'
})
export class NumPickerComponent {

  @Output() readonly numberSelected: EventEmitter<number> = new EventEmitter<number>();

  @Input() selected?: number;

  numbers = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14 ];

  onSelection(selected: number) {
    this.numberSelected.emit(selected);
  }

  trackByNumber(_index:number, value: number) {
    return value;
  }

}
